import EditIcon from '@mui/icons-material/Edit';
import FolderIcon from '@mui/icons-material/Folder';
import { IconButton, Stack } from '@mui/material';
import { useState } from 'react';

import { LineClampTypography } from '@/components/atoms/LineClampTypography';
import { useLongPress } from '@/components/hooks/useLongPress';

const NameEditableCell = (props: {
  name: string;
  onClickEdit: () => void;
  enableLongPress?: boolean;
  longPressDelay?: number;
}) => {
  const [hovering, setHovering] = useState(false);

  const longPressProps = useLongPress(
    props.onClickEdit,
    props.longPressDelay ?? 300
  );

  const handleMouseLeave = () => {
    setHovering(false);
    if (props.enableLongPress && longPressProps.onMouseLeave) {
      longPressProps.onMouseLeave();
    }
  };

  return (
    <Stack
      direction="row"
      width={1}
      spacing={1}
      alignItems="center"
      onMouseEnter={() => setHovering(true)}
      onMouseLeave={handleMouseLeave}
      {...(props.enableLongPress
        ? {
            onMouseDown: longPressProps.onMouseDown,
            onMouseUp: longPressProps.onMouseUp,
            onTouchStart: longPressProps.onTouchStart,
            onTouchEnd: longPressProps.onTouchEnd,
          }
        : {})}
    >
      <FolderIcon sx={{ fontSize: '1.8rem' }} htmlColor="#9dc5f5" />
      <LineClampTypography variant="body1" rowCount={2}>
        {props.name}
      </LineClampTypography>
      {hovering && (
        <IconButton
          onClick={(ev) => {
            ev.stopPropagation();
            ev.preventDefault();
            props.onClickEdit();
          }}
          size="small"
        >
          <EditIcon fontSize="small" />
        </IconButton>
      )}
    </Stack>
  );
};
export default NameEditableCell;
